<template>
  <div>
    <!--Card maior-->
    <b-card header="Adicionar Perfis de Acesso">
      <b-card-text>
        Escolha os perfis e as UGs que os receberão,depois clique em adicionar.
      </b-card-text>
      <!--Grupo de cards em linha-->

      <b-card-group deck>
        <!--Card de perfis de acesso disponíveis-->

        <b-card header="Perfis de acesso disponíveis" class="text-center">
          <!--Barra de pesquisa-->
          <default-form-validation-provider
            label="Perfil de acesso"
            v-slot="defaultState"
          >
            <multiselect
              v-model="Perfis.Descricao"
              :state="defaultState.state"
              placeholder="Selecione um perfil"
              track-by="Id"
              :options="listaPerfis"
              label="Descricao"
              :allow-empty="true"
              v-bind="multiselectprops"
              @select="adicionarPerfil"
            >
              <template slot="noOptions">
                <small><i>Erro ao obter dados.</i></small>
              </template>
              <template slot="noResult">
                <i>Sem resultados.</i>
              </template>
            </multiselect>
          </default-form-validation-provider>
          <div class="d-flex flex-column mb-3 align-items-start text-left">
            <span>Predefinições:</span>
            <div class="d-flex flex-row justify-content-center mt-2">
              <b-button
                variant="outline-secondary"
                size="sm"
                class="mr-1"
                @click="listarMaisUtilizados"
                >Mais utilizados</b-button
              >
              <b-button
                variant="outline-secondary"
                size="sm"
                class="mx-1"
                @click="listarControleInterno"
                >Controle Interno</b-button
              >
              <b-button
                variant="outline-secondary"
                size="sm"
                class="mx-1"
                @click="listarComunicacao"
                >Comunicação</b-button
              >
              <b-button
                variant="outline-secondary"
                size="sm"
                class="mx-1"
                @click="listarPermissoesInternas"
                >Permissões Internas</b-button
              >
            </div>
          </div>
          <div>
            <b-table
              striped
              hover
              stacked="md"
              :items="listaPerfisSelecionados"
              :fields="[
                { key: 'Descricao', label: 'Perfis selecionados' },
                { key: 'actions', label: '' },
              ]"
            >
              <template slot="cell(actions)" slot-scope="perfilData">
                <b-button size="sm" @click="removerItemPerfil(perfilData.item)">
                  <font-awesome-icon icon="trash" />
                </b-button>
              </template>
            </b-table>
          </div>
          <!--Botão para remover todos os perfis-->
          <b-button
            class="float-right m-1"
            size="sm"
            @click="removerPerfis"
            :disabled="listaPerfisSelecionados.length === 0"
          >
            Remover todos
          </b-button>
        </b-card>

        <!--Card de UGs disponíveis-->

        <b-card header="UGs disponíveis">
          <!--Barra de pesquisa-->
          <default-form-validation-provider
            label="Unidade Gestora"
            v-slot="defaultState"
          >
            <multiselect
              v-model="Ugs.Nome"
              open-direction="bottom"
              :state="defaultState.state"
              placeholder="Selecione uma UG"
              track-by="Codigo"
              :options="listaUGs"
              label="Nome"
              :allow-empty="true"
              v-bind="multiselectprops"
              @select="adicionarUG"
            >
              <template slot="noOptions">
                <small><i>Erro ao obter dados.</i></small>
              </template>
              <template slot="noResult">
                <i>Sem resultados.</i>
              </template>
            </multiselect>
          </default-form-validation-provider>
          <b-table
            striped
            hover
            stacked="md"
            :items="listaUgsSelecionadas"
            :fields="[
              { key: 'Nome', label: 'UGs selecionadas' },
              { key: 'actions', label: '' },
            ]"
          >
            <template slot="cell(actions)" slot-scope="perfilData">
              <b-button size="sm" @click="removerItemUG(perfilData.item)">
                <font-awesome-icon icon="trash" />
              </b-button>
            </template>
          </b-table>
          <!--Botão para remover ugs-->
          <div class="mt-4">
            <b-button
              class="float-right m-1"
              size="sm"
              @click="removerUGs"
              :disabled="listaUgsSelecionadas.length === 0"
            >
              Remover todas
            </b-button>
          </div>
        </b-card>
      </b-card-group>

      <!--Botão para adicionar as alterações-->
      <div class="mt-4">
        <b-button
          variant="success"
          size="sm"
          @click="adicionarPermissao"
          :disabled="
            listaPerfisSelecionados.length === 0 ||
            listaUgsSelecionadas.length === 0
          "
        >
          <font-awesome-icon icon="plus" />
          Adicionar
        </b-button>
      </div>
    </b-card>

    <!--Card de perfis deste usuario-->
    <AbaCarregarPermissoesUsuario
      v-if="usuario"
      :usuario="usuario"
      @evento-mudanca="atualizarEvento"
    />
  </div>
</template>

<script lang="ts">
import ugService from "@/services/administracao/ugService";
import usuarioService from "@/services/administracao/usuarioService";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import perfisService from "@/services/administracao/perfisService";
import { Perfil } from "@/types/administracao/cadastro-permissoes/perfil";
import { Usuario } from "@/types/administracao/usuarios/usuario";
import { EnvioUsuarioPermissoes } from "@/types/administracao/usuarios/envio-usuario-permissoes";

import { UtilsTS } from "@/utilsts";
import { PropType } from "vue";
import { mixins } from "vue-class-component";
import { Component, Vue, Watch } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import { MultiSelectDefaultProps } from "@/types/form-default-props";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { store } from "@/store";
import AbaCarregarPermissoesUsuario from "./AbaCarregarPermissoesUsuario.vue";

const CompProps = Vue.extend({
  name: "AbaEditarDadosPermissoesUsuario",
  components: {
    Multiselect,
    DefaultFormValidationProvider,
    AbaCarregarPermissoesUsuario,
  },
  props: {
    usuario: {
      type: Object as PropType<Usuario>,
      required: false,
    },
  },
});

@Component
export default class AbaEditarDadosPermissoesUsuario extends mixins(
  UtilsTS,
  CompProps
) {
  Ugs: UnidadeGestoraResumida = new UnidadeGestoraResumida();
  Perfis: Perfil = new Perfil();
  listaUGs: UnidadeGestoraResumida[] = [];
  listaPerfis: Perfil[] = [];
  multiselectprops = MultiSelectDefaultProps;
  listaPerfisSelecionados: Perfil[] = [];
  listaUgsSelecionadas: UnidadeGestoraResumida[] = [];

  //Lista feita para agrupar os perfis relacionados a s ugs

  //lista feita para o envio dos ids para a api
  listaPermissoesEnvio: EnvioUsuarioPermissoes[] = [];
  // Quando a página é inicializada essa função é executada
  async mounted() {
    //console.log(this.usuario)

    try {
      store.blockScreen = true;
      await Promise.all([this.carregarUGs(), this.carregarPerfis()]);
    } catch (e) {
      console.error(e);
    } finally {
      store.blockScreen = false;
    }
  }

  //Busca as UGs ativas
  async carregarUGs() {
    try {
      this.listaUGs = await ugService.buscarUGsAtivas();
    } catch (e: any) {
      this.tratarError(e);
    }
  }

  //Buscar Perfis
  async carregarPerfis() {
    try {
      this.listaPerfis = await perfisService.listarPerfis();
      this.listaPerfis.sort((a, b) => a.Descricao.localeCompare(b.Descricao));
      //console.log(this.listaPerfis);
    } catch (e: any) {
      this.tratarError(e);
    }
  }

  //Converte as propriedades da prop usuario para um array

  //adiciona novo perfil
  adicionarPerfil(perfil: Perfil) {
    if (!this.listaPerfisSelecionados.includes(perfil)) {
      this.listaPerfisSelecionados.push(perfil);
    }
  }

  //remove todos os perfis
  removerPerfis() {
    this.listaPerfisSelecionados = [];
  }

  //remover um item específico da lista de perfis selecionados
  removerItemPerfil(item: Perfil) {
    this.listaPerfisSelecionados = this.listaPerfisSelecionados.filter(
      (perfil) => perfil.Id !== item.Id
    );
  }

  //adicionar UGs
  adicionarUG(UG: UnidadeGestoraResumida) {
    if (!this.listaUgsSelecionadas.includes(UG)) {
      this.listaUgsSelecionadas.push(UG);
    }
  }
  //remove todas as UGs
  removerUGs() {
    this.listaUgsSelecionadas = [];
  }
  //Remove um item específico da lista de UGs selecionadas
  removerItemUG(item: UnidadeGestoraResumida) {
    this.listaUgsSelecionadas = this.listaUgsSelecionadas.filter(
      (UG) => UG.Nome !== item.Nome
    );
  }
  //FUnção para solicitar a requisição para adicionar as permissoes ao usuario
  async adicionarPermissao() {
    //lógica para adicionar e converter os perfis para a listaPermissoesEnvio
    this.listaUgsSelecionadas.forEach((ug) => {
      for (let i = 0; i < this.listaPerfisSelecionados.length; i++) {
        const idUsuario = this.usuario.ID_USUARIO;
        const idUnidadeGestora = Number(ug.idCRP);
        const idPerfil = this.listaPerfisSelecionados[i].Id;
        //

        if (!idUnidadeGestora)
          return this.$toast.error("Id da ug não recebido");

        const novoObjetoPermissaoEnviar: EnvioUsuarioPermissoes = {
          idUsuario,
          idUnidadeGestora,
          idPerfil,
        };
        this.listaPermissoesEnvio.push(novoObjetoPermissaoEnviar);
      }
    });
    //console.log(this.listaPermissoesEnvio)

    //Tratativa para fazer a requisição
    try {
      store.blockScreen = true;
      const response = await usuarioService.adicionarPermissaoUsuario(
        this.listaPermissoesEnvio
      );

      //console.log(`Permissões adicionadas com sucesso`)
      this.atualizarEvento();
      if (this.listaPermissoesEnvio.length <= 1)
        this.$toast.success("Permissão adicionada com sucesso!");
      else this.$toast.success("Permissões adicionadas com sucesso!");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      //retira tela de carregamento
      store.blockScreen = false;
      //zerando as listas utilizadas
      this.listaPerfisSelecionados = [];
      this.listaUgsSelecionadas = [];
      this.listaPermissoesEnvio = [];
      //Chamando a função para reorganizar o componente
    }
  }

  //Essa função emite um evento para o componente pai, para que ele atualize os dados de usuario
  atualizarEvento() {
    //console.log('emit 1')
    this.$emit("evento-mudanca-2");
  }

  //funções de prefefinição
  listarControleInterno() {
    const novosPerfis = this.listaPerfis.filter(
      (perfil: Perfil) => perfil.Sigla !== "ADM"
    );
    //console.log("Controle Interno", novosPerfis);
    // Adicionar novos perfis à lista existente, garantindo que não haja itens duplicados
    this.listaPerfisSelecionados = [
      ...this.listaPerfisSelecionados,
      ...novosPerfis.filter(
        (novoPerfil) =>
          !this.listaPerfisSelecionados.some(
            (perfil) => perfil.Sigla === novoPerfil.Sigla
          )
      ),
    ];
  }

  listarComunicacao() {
    const nomes = ["AVI", "NOT", "MDT"];

    const perfisComunicacao = this.listaPerfis.filter((perfil: Perfil) =>
      nomes.includes(perfil.Sigla!)
    );

    //console.log("Controle Comunicação", perfisComunicacao);
    this.listaPerfisSelecionados = [
      ...this.listaPerfisSelecionados,
      ...perfisComunicacao.filter(
        (novoPerfil) =>
          !this.listaPerfisSelecionados.some(
            (perfil) => perfil.Sigla === novoPerfil.Sigla
          )
      ),
    ];
  }

  listarMaisUtilizados() {
    const maisUtilizados = [
      "MDT",
      "NOT",
      "COT",
      "COV",
      "LIC",
      "PCA",
      "PCO",
      "REL",
      "LRF",
      "AVI",
      "REM",
    ];

    const perfisMaisUtilizados = this.listaPerfis.filter((perfil: Perfil) =>
      maisUtilizados.includes(perfil.Sigla!)
    );

    //console.log("Mais utilizados", perfisMaisUtilizados);
    this.listaPerfisSelecionados = [
      ...this.listaPerfisSelecionados,
      ...perfisMaisUtilizados.filter(
        (novoPerfil) =>
          !this.listaPerfisSelecionados.some(
            (perfil) => perfil.Sigla === novoPerfil.Sigla
          )
      ),
    ];
  }

  listarPermissoesInternas() {
    const nomes = ["CAV", "OUT", "AUT"];

    const perfisPermissoesInternas = this.listaPerfis.filter((perfil: Perfil) =>
      nomes.includes(perfil.Sigla!)
    );

    this.listaPerfisSelecionados = [
      ...this.listaPerfisSelecionados,
      ...perfisPermissoesInternas.filter(
        (novoPerfil) =>
          !this.listaPerfisSelecionados.some(
            (perfil) => perfil.Sigla === novoPerfil.Sigla
          )
      ),
    ];
  }
}
</script>
